import { IntegrationStateEnum } from '@enum/integration-state.enum';
import { UnifiedApiEnum } from '@enum/unified-api.enum';
import { ConnectionStateEnum } from '@interface/connection/connection.interface';

export const IntegrationsSortList = [
  { value: null, label: 'Default' },
  { value: 'asc', label: 'A-Z' },
  { value: 'desc', label: 'Z-A' },
];

export const IntegrationSectorsList = [
  { label: 'All', value: null },
  ...Object.entries(UnifiedApiEnum).map(([label, value]) => ({ label, value })),
];

export const IntegrationStatesList = [
  { label: 'All', value: null },
  // ...Object.entries(ConnectionStateEnum).map(([label, value]) => ({ label, value })),
  { label: 'Added', value: ConnectionStateEnum.Added },
  { label: 'Available', value: ConnectionStateEnum.Available },
  { label: 'Disabled', value: IntegrationStateEnum.DISABLED },
];
